import React from "react";

const Contacto = () => {
  return (
    <div className="contacto-page flex flex-col">
      <div className="contacto-title-sec flex aic jc">
        <div className="contacto-title">CLUB NFTs TOTAL ART </div>
      </div>
      <div className="contacto-sec flex flex-col">
        <div className="wrap wrapWidth flex flex-col">
          <div className="nft-present flex flex-col">
            <div className="page-tag">
              Bienvenid@ a tu club de inversiones en NFTs Art
            </div>
            <div className="pres-desc">
              Somos tu club de inversores especializado en el sector del arte y
              de los NFTs. Contamos con el respaldo de NFTs Total Art y el grupo
              Invertercript.
              <br />
              <br /> Formación permanente, acceso prioritario a lanzamientos y
              muchos otros beneficios te esperan. ¡Forma parte de nuestro club!
            </div>
          </div>
          <div className="buy-nft flex aic">
            <div className="left flex aic jc">
              <div className="page-tag">
                Beneficios del Club
                <br /> NFTs Total Art
              </div>
            </div>
            <div className="right flex flex-col">
              <div className="item flex aic">
                <div className="numb">01.</div>
                <div className="dec">
                  Invitación exclusiva a eventos para miembros del club.
                </div>
              </div>
              <div className="item flex aic">
                <div className="numb">02.</div>
                <div className="dec">Pertenecerás a una comunidad.</div>
              </div>
              <div className="item flex aic">
                <div className="numb">03.</div>
                <div className="dec">
                  Formación permanente y ventajas en la contratación de
                  servicios adicionales.
                </div>
              </div>
              <div className="item flex aic">
                <div className="numb">04.</div>
                <div className="dec">Acceso a oportunidades de inversión.</div>
              </div>
              <div className="item flex aic">
                <div className="numb">05.</div>
                <div className="dec">
                  Early access para inversiones en base a tu categoría en el
                  Club.{" "}
                </div>
              </div>
              <div className="item flex aic">
                <div className="numb">06.</div>
                <div className="dec">
                  Acceso prioritario a nuevos lanzamientos.{" "}
                </div>
              </div>
              <div className="item flex aic">
                <div className="numb">07.</div>
                <div className="dec">
                  Acceso a oportunidades de coinversión.
                </div>
              </div>
              <div className="item flex aic">
                <div className="numb">08.</div>
                <div className="dec">
                  Posibilidad de formar parte de nuestra red de colaboradores e
                  integrante de nuestro grupo.
                </div>
              </div>
            </div>
          </div>
          <div className="actions flex aic jc">
            <div className="btn button">
              Quiero ser miembro del club NFTs Total Art
            </div>
          </div>
          <div className="how-member flex aic flex-col">
            <div className="page-tag">¿Cómo ser miembro del club?</div>
            <div className="how-desc">
              Con la subida de tus NFTs de arte podrás obtener diferentes tipos
              de membresia.
            </div>
            <div className="member-block flex aic">
              <div className="member-item flex flex-col">
                <img src="./images/insignia1.png" className="img" />
                <div className="item-tag">Miembro plata</div>
                <div className="item-desc">
                  Acceso en exclusiva durante 12 meses con la subida de más de
                  100 NFTs.{" "}
                </div>
              </div>
              <div className="member-item flex flex-col">
                <img src="./images/insignia2.png" className="img" />
                <div className="item-tag">Miembro plata</div>
                <div className="item-desc">
                  Acceso en exclusiva durante 12 meses con la subida de más de
                  100 NFTs.{" "}
                </div>
              </div>
              <div className="member-item flex flex-col">
                <img src="./images/insignia1.png" className="img" />
                <div className="item-tag">Miembro plata</div>
                <div className="item-desc">
                  Acceso en exclusiva durante 12 meses con la subida de más de
                  100 NFTs.{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="talk-later flex flex-col">
        <div className="page-tag">¿Hablamos?</div>
        <div className="contact-us-sec flex">
          <div className="contact-us flex flex-col rel aic">
            <div className="block flex flex-col abs">
              <div className="blk-tag">
                Si tienes alguna pregunta, dejanos tu mensaje y nos pondremos en
                contacto contigo en la mayor brevedad posible.{" "}
              </div>
              <div className="fields">
                <input type="text" className="txt" placeholder="Nombre" />
                <input type="text" className="txt" placeholder="Email" />
                <input type="text" className="txt" placeholder="Telefono" />
                <input type="text" className="txt" placeholder="Asunto" />
              </div>
              <textarea type="text" className="txt" placeholder="Mensaje" />
              <div className="row flex aic">
                <input type="checkbox" className="check-box" />
                <div className="lbl">
                  He leido y acepto la política de protección de datos.
                </div>
              </div>
              <div className="action flex aic jc">
                <div className="btn button">Enviar</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contacto;
